import React from "react";
import Footer from "../components/Footer";
import Heading from "../components/Heading";
import Layout from "../components/Layout";
import Navbar from "../components/Navbar";
import SEO from "../components/SEO";

export default function AloobaForWorkSignUp() {
  if (typeof window !== 'undefined') {
    window.location.href = "/book-discovery-call";
  }
  return (
    <Layout>
      <SEO 
        title="Alooba"
      />
      <Navbar dark="true" />
      <Heading title="Redirecting..."/>
      <Footer />
    </Layout>
  )
}
